export default "__VITE_ASSET__B2MTr5r2__"